









































import { Component, Vue, Prop } from 'vue-property-decorator'
import { APP_TOPIC_MAP } from '@/apps/open/constants'

@Component({
  componentName: 'EditMsgType'
})
export default class EditMsgType extends Vue {
  activeName: string = '订阅事件'
  tableData: object[] = []

  get hasNewChecked () {
    const originCheckedSum = this.tableData.filter((i:any) => i.originChecked)
    const checkedSum = this.tableData.filter((i:any) => i.checked)
    return checkedSum.length > originCheckedSum.length
  }

  @Prop({
    default: ''
  })
  value?: string

  @Prop()
  submit!: Function

  @Prop()
  onCancel!: Function

  handleSubmit () {
    let newTopic:any = this.tableData.filter((i:any) => {
      return i.checked
    })
    newTopic = newTopic.map((i:any) => {
      return i.keys.join(',')
    })
    this.submit(newTopic.join(','))
  }

  initTableData () {
    this.tableData = APP_TOPIC_MAP.map((i:any) => {
      i.originChecked = false
      i.checked = false
      i.status = false
      return i
    })
  }

  initData () {
    this.initTableData()
    if (!this.value) return
    const valueKeys:any = this.value && this.value.split(',')
    this.tableData.map((i:any) => {
      let flag = false
      i.keys.forEach((v:any) => {
        if (valueKeys.includes(v)) {
          flag = true
        } else {
          flag = false
        }
      })
      i.status = flag
      i.originChecked = flag
      i.checked = flag
      return i
    })
  }

  created () {
    this.initData()
  }
}
